import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import RestService from 'src/app/utils/restservice';

@Injectable({
  providedIn: 'root'
})
export class ProviderService {
  
  constructor(private http: HttpClient, private restService: RestService) {}
  
  search(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('provider/search', val_params);
  }

  list(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('provider/list', val_params);
  }

  get(val_id: number) {
    return this.restService.get('provider/edit', val_id);
  }

  save(data: any) {
    return this.restService.save('provider/save', data);
  }

  updateSave(data: any) {
    return this.restService.save('provider/update/save', data);
  }

  update(val_id: number, data: any) {
    return this.restService.update('provider/update', val_id, data);
  }

  delete(val_id: number) {
    return this.restService.delete('provider/delete', val_id);
  }
}
